export default "__VITE_ASSET__Cjx2Nva$__"